module.exports = __webpack_public_path__ + "img/icon_category_00_w.84e06e03.svg";